if (!customElements.get("switch-tip")) {
  customElements.define(
    "switch-tip",
    class SwitchTip extends HTMLElement {
      constructor() {
        super();
        this.allStepButtons = this.querySelectorAll(".js-step-button");
        this.allStepContent = this.querySelectorAll(".js-step-content");

        this.setupEventListeners();
      }
      connectedCallback() {
        this.allStepButtons.forEach((button) => {
          if (button.classList.contains("active")) {
            this.setActiveItem(button);
          }
        });
      }
      setupEventListeners() {
        this.allStepButtons.forEach((button) =>
          button.addEventListener(
            "mouseenter",
            this.handleStepButtonHover.bind(this)
          )
        );
      }
      setActiveItem(activeButton) {
        const activeStep = activeButton.dataset.step;

        this.allStepButtons.forEach((button) => {
          if (button === activeButton) {
            button.classList.add("active");
            button.setAttribute("aria-expanded", "true");
          } else {
            button.classList.remove("active");
            button.setAttribute("aria-expanded", "false");
          }
        });
        this.allStepContent.forEach((content) => {
          if (content.id === activeStep) {
            content.classList.add("active");
            content.removeAttribute("inert");

            setTimeout(
              () => content.firstElementChild.classList.add("active"),
              600
            );
            content.style.maxHeight = `calc(${content.scrollHeight}px)`;
          } else {
            content.classList.remove("active");
            content.setAttribute("inert", '');
            content.firstElementChild.classList.remove("active");
            content.style.maxHeight = `0px`;
          }
        });
      }
      handleStepButtonHover(event) {
        const button = event.target;
        this.setActiveItem(button);
      }
    }
  );
}
